import Text from "@ingka/text";
import Tooltip from "@ingka/tooltip";
import Button from "@ingka/button";
import RadioButtonGroup from "@ingka/radio-button-group";
import questionMarkCircle from "@ingka/ssr-icon/paths/question-mark-circle";

type Props = {
  radioBtnState: boolean | null;
  disabled?: boolean;
  onChange: (value: boolean) => void;
};

export function ConfirmFilesOriginality({
  radioBtnState,
  disabled,
  onChange,
}: Props) {
  return (
    <>
      <div className="mb-space100 ml-space250 flex items-center gap-x-space25">
        <Text tagName="h2" headingSize="m" className="text-center text-lg">
          Are you uploading only new files?
        </Text>
        <Tooltip
          position="top"
          tooltipText="It is very important that we can link all assets to their originals in Ingka DAM, we need this information for statistics but also to make sure that we can find all assets if an issue comes up with the original and it needs to be removed for legal reasons."
        >
          <Button
            //TODO: Add aria-label for accessibility
            iconOnly
            size="small"
            ssrIcon={questionMarkCircle}
            type="tertiary"
          />
        </Tooltip>
      </div>
      <RadioButtonGroup
        className="max-w-2xl"
        list={[
          {
            id: "original",
            label:
              "Yes, I confirm that all files in this request are new and not yet uploaded to Ingka DAM",
            checked: radioBtnState === true,
            onChange: () => {
              onChange(true);
            },
            disabled: disabled,
          },
          {
            id: "notOriginal",
            label:
              "No, one or more files in this request are edited versions created from an asset found in Ingka DAM",
            checked: radioBtnState === false,
            onChange: () => {
              onChange(false);
            },
          },
        ]}
      />
    </>
  );
}
